import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

export default function OmOs() {
  useEffect(() => {
    document.title = 'Om os - Borgs Køreskole I/S'
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        'Læs om Borgs Køreskole I/S i Kalundborg. Vi tilbyder tryg og nærværende køreundervisning på Vestsjælland med fokus på den enkelte elev.'
      )
    }
  }, [])

  return (
    <div className="bg-slate-50 min-h-screen py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h1 className="font-header text-4xl sm:text-5xl font-extrabold text-slate-900 tracking-tight">
            Om Borgs Køreskole I/S
          </h1>
          <p className="mt-4 text-slate-600 text-base sm:text-lg leading-relaxed">
            Vi leverer tryg, seriøs og nærværende køreundervisning i Kalundborg og det øvrige Vestsjælland.
          </p>
        </div>

        {/* Content Section 1: Story & Mission */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          <div className="space-y-6">
            <h2 className="font-header text-3xl font-bold text-slate-900">
              Kørekort i trygge rammer uden stress
            </h2>
            <p className="text-slate-600 text-base leading-relaxed">
              Hos Borgs Køreskole I/S tror vi på, at man lærer bedst i en rolig og støttende atmosfære. Vores instruktører har mange års erfaring i at undervise både unge og voksne, herunder elever der måtte føle nervøsitet eller usikkerhed i starten.
            </p>
            <p className="text-slate-600 text-base leading-relaxed">
              Vi holder vores holdstørrelser tilpas små til, at der altid er tid til den enkelte elev. Det sikrer en markant højere beståelsesprocent ved både teori- og den praktiske køreprøve.
            </p>

            <div className="pt-2 grid grid-cols-2 gap-4">
              <div className="bg-white p-4 border border-slate-200 shadow-sm">
                <i className="fa-solid fa-graduation-cap text-emerald-600 text-2xl mb-2" aria-hidden="true"></i>
                <h4 className="font-header font-bold text-slate-900">Godkendte Instruktører</h4>
                <p className="text-xs text-slate-500 mt-1">Stort engagement og pædagogisk tilgang.</p>
              </div>
              <div className="bg-white p-4 border border-slate-200 shadow-sm">
                <i className="fa-solid fa-leaf text-emerald-600 text-2xl mb-2" aria-hidden="true"></i>
                <h4 className="font-header font-bold text-slate-900">Den Grønne Profil</h4>
                <p className="text-xs text-slate-500 mt-1">Velkendte grønne skolevogne i bybilledet.</p>
              </div>
            </div>
          </div>

          <div className="relative overflow-hidden shadow-2xl border border-slate-200 aspect-square sm:aspect-video lg:aspect-square">
            <img
              src="/_assets/om-borgskoereskole-bil.webp"
              alt="Den grønne skolebil og instruktør - Borgs Køreskole I/S"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Company Info Box */}
        <div className="bg-emerald-900 text-white p-8 sm:p-12 shadow-xl mb-16">
          <div className="max-w-3xl mx-auto text-center space-y-6">
            <h2 className="font-header text-3xl font-bold">
              Borgs Køreskole I/S · Stamdata
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-0 text-left pt-4 divide-y sm:divide-y-0 sm:divide-x divide-emerald-800/80">
              <div className="pb-4 sm:pb-0 sm:pr-6">
                <span className="text-emerald-400 text-xs font-bold uppercase block mb-1">Virksomhed</span>
                <strong className="text-white text-base block font-header">Borgs Køreskole I/S</strong>
                <span className="text-xs text-emerald-200">CVR: 43296000</span>
              </div>
              <div className="py-4 sm:py-0 sm:px-6">
                <span className="text-emerald-400 text-xs font-bold uppercase block mb-1">Adresse</span>
                <strong className="text-white text-base block font-header">Elmegade 19</strong>
                <span className="text-xs text-emerald-200">4400 Kalundborg</span>
              </div>
              <div className="pt-4 sm:pt-0 sm:pl-6">
                <span className="text-emerald-400 text-xs font-bold uppercase block mb-1">Kontakt</span>
                <strong className="text-white text-base block font-header whitespace-nowrap">
                  <a href="tel:21470187" className="hover:text-emerald-200 transition-colors">21 47 01 87</a> / <a href="tel:23200425" className="hover:text-emerald-200 transition-colors">23 20 04 25</a>
                </strong>
                <a href="mailto:info@borgskoereskole.dk" className="text-xs text-emerald-200 hover:underline whitespace-nowrap">info@borgskoereskole.dk</a>
              </div>
            </div>

            <div className="pt-6">
              <Link
                to="/kontakt"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white text-emerald-950 font-bold text-sm shadow-md hover:bg-emerald-100 transition-colors"
              >
                <span>Kontakt os for tilmelding</span>
                <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
              </Link>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}
